import HttpService from './httpService';
import config from '../../config';

class ProfesoresApiService extends HttpService {
  constructor(baseUrl, generalCatch) {
    super(baseUrl, generalCatch);
  }

  async obtenerProfesores({ centro, codigo, nombre, apellidos, email, movil }) {
    return this.get('obtenerProfesores', {
      params: { centro, codigo, nombre, apellidos, email, movil },
    });
  }

  async obtenerDetallesProfesor({ empresaId, profesoresId }) {
    return this.get('obtenerDetallesProfesor', {
      params: { empresaId, profesoresId },
    });
  }

  async upsertProfesor(values) {
    // values debe contener todos los datos del profesor, incluido empresaId
    return this.post('upsertProfesor', {
      params: { ...values },
    });
  }

  // Asigna el director de una sede. empresaId: 'CEDESCA' | 'CNTEC'; indice: el Codigo
  // del profesor. Pasar { silent: true } para gestionar los errores 400/404/500
  // localmente (el backend devuelve { error } en el body) sin disparar el toast global.
  async asignarDirector({ empresaId, indice }, options = {}) {
    return this.post('asignarDirector', { empresaId, indice }, options);
  }
}

const profesoresApiService = new ProfesoresApiService(config.REACT_APP_NODE_API);

export default profesoresApiService;
